<template>
	<div class="incomeAll">
		<h6>绑定VIP (已绑定)</h6>

		<section class="system">
			<article class="sysHead ">
				<form action="" autocomplete="off">
					<div class="sys_form  flex zhong">
						<label>卡号：</label>
						<div class="sys-right">
							<input type="text" v-model="cardNo" placeholder="请输入" />
						</div>
					</div>
					<div class="sys_form  flex zhong">
						<label>密码：</label>
						<div class="sys-right">
							<input :type="isSee ? 'passWord' : 'text'" v-model="password" placeholder="请输入" />
							<img style="cursor: pointer;" :src="isSee ? require('../../image/home_d.png') : require('../../image/home_dd.png')" @click="seeClick()" />
						</div>
					</div>
					<button type="button" v-on:click="BindCard">确定绑定</button>
				</form>
			</article>
			<hgroup class="flex zhong">
				<i></i>
				<p>我的绑定记录</p>
			</hgroup>

			<article class="table">
				<hgroup class="flex">
					<p>VIP类型</p>
					<p>卡号</p>
					<p>绑定时间</p>
				</hgroup>
				<ul>
					<li class="flex" v-for="(item, index) in list" :key="index">
						<p>{{ item.Name }}</p>
						<p>{{ item.CardNo }}</p>
						<p>{{ item.CreateTime }}</p>
					</li>
				</ul>
			</article>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {
			currentPage4: 4,
			list: [],
			cardNo: '',
			password: '',
			isSee: false
		};
	},
	mounted() {
		this.GetBindCard();
	},
	methods: {
		// 显示或隐藏密码
		seeClick() {
			this.isSee = !this.isSee;
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
		},
		// 获取已绑定卡号
		GetBindCard: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetBindCard',
				'GET',
				{},
				function(res) {
					console.log('获取已绑定卡号');
					console.log(res);
					if (res.code === 0) {
						that.list = res.data;
					}
				},
				function(res) {}
			);
		},
		// 绑定卡号
		BindCard: function() {
			var that = this;
			if (!that.cardNo || that.cardNo.length === 0) {
				this.$util.showError('请输入卡号');
				return;
			}
			if (!that.password || that.password.length === 0) {
				this.$util.showError('请输入密码');
				return;
			}
			that.$api.HtppRequest(
				'WebsiteSet/BindCard?CardNo=' + that.cardNo + '&password=' + that.password,
				'GET',
				{},
				function(res) {
					console.log('绑定卡号');
					console.log(res);
					if (res.code === 0) {
						that.$util.showOk(res.msg);
						that.GetBindCard();
						that.cardNo = '';
						that.password = '';
					} else {
						that.$util.showError(res.msg);
					}
				},
				function(res) {}
			);
		}
	}
};
</script>

<style scoped>
.pageDiv {
	overflow: hidden;
	margin-top: 20px;
}

.table li p {
	font-size: 14px;
	width: 33.33%;
	line-height: 60px;
	text-align: center;
}

.table li p {
	border-right: solid 1px #e6e6e6;
}

.table li {
	border-bottom: solid 1px #e6e6e6;
}

.table li:last-child {
	border-bottom: none;
}

.table li p:last-child {
	border-right: none;
}

.table ul {
	overflow: hidden;
}

.table hgroup p {
	font-size: 14px;
	background-color: #eaeaea;
	width: 33.33%;
	line-height: 60px;
	text-align: center;
}

.table {
	overflow: hidden;
	border: solid 1px #e6e6e6;
	box-sizing: border-box;
}

.system > hgroup i {
	display: inline-block;
	width: 4px;
	height: 20px;
	border-radius: 50px;
	background-color: #333;
}

.system > hgroup p {
	font-size: 16px;
	margin-left: 15px;
}

.system > hgroup {
	margin: 30px auto;
}

.sys-right input {
	width: 300px;
	font-size: 14px;
	color: #333;
	height: 40px;
	line-height: 40px;
	text-indent: 1em;
}

.sys-right input::-webkit-input-placeholder {
	color: #999;
}

.sys-right input:-moz-placeholder {
	color: #999;
}

.sys-right input:-ms-input-placeholder {
	color: #999;
}

.sys_form label {
	font-size: 14px;
	display: inline-block;
	width: 80px;
	text-align: right;
}
.sys-right{
	width: calc( 100% - 100px );
	margin-left: 20px;
	display: flex;
	align-items: center;
	height: 40px;
	background-color: #fff;
	border: solid 1px #e6e6e6;
	border-radius: 4px;
	line-height: 40px;
	padding-right: 15px;
}

.sys_form {
	width: 40%;
}
.sys-right > img {
	width: 20px;
	height: 20px;
	display: block;
}

.sysHead form {
	display: flex;
	width: 100%;
}

.sysHead {
	background-color: #eaeaea;
	padding: 40px;
}

.system {
	overflow: hidden;
	padding: 20px;
}

/* safety */

.incomeAll > h6 {
	border-bottom: solid 1px #e6e6e6;
	font-size: 16px;
	color: #333;
	height: 62px;
	line-height: 62px;
	text-indent: 20px;
	position: relative;
}

.incomeAll > h6::after {
	content: '';
	width: 130px;
	height: 2px;
	background-color: #333;
	position: absolute;
	left: 20px;
	bottom: 0;
	z-index: 0;
}

.sysHead button {
	font-size: 14px;
	color: #fff;
	border-radius: 4px;
	background-color: #333;
	height: 44px;
	line-height: 44px;
	width: 100px;
	text-align: center;
	display: block;
	margin-left: 20px;
}
</style>
